/* jshint esnext: true */

const tilesets = {
	1: [
		'Black and White',
		'000000',
		'dark'
	],
	2: [
		'Green',
		'00e436',
		'light'
	],
	3: [
		'Dusk',
		'ffccaa',
		'dark'
	],
	4: [
		'Printer Friendly',
		'c2c3c7',
		'light'
	],
	5: [
		'Rock Garden',
		'008751',
		'dark'
	],
	6: [
		'ManPac',
		'000000',
		'dark'
	],
	7: [
		'Flower Power',
		'29adff',
		'dark'
	],
	8: [
		'Pipes',
		'1d2b53',
		'dark'
	],
	9: [
		'Patchwork',
		'000000',
		'dark'
	]
};


const storeData = [
	[ 1, 0 ],
	[ 2, 100 ],
	[ 3, 200 ],
	[ 4, 400 ],
	[ 6, 800 ],
	[ 7, 1600 ],
	[ 8, 3200 ],
	[ 9, 6400 ]
];
